/**
 * @generated SignedSource<<6137d33e6f062f42d79c2545b3dd01d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TransportationCode = "CADDIE" | "CADDIE_CART" | "CART" | "FULL_CART" | "MOTOR_PULL_CART" | "PRIVATE_CART" | "PULL_CART" | "SINGLE_CART" | "WALK";
export type CustomerListQuery$variables = {
  agendaId?: string | null | undefined;
  eventIdToExcludeParticipantsFromResults?: string | null | undefined;
  includeTransportationType: boolean;
  players?: ReadonlyArray<string | null | undefined> | null | undefined;
  search?: string | null | undefined;
  slotId: string;
};
export type CustomerListQuery$data = {
  readonly session: {
    readonly currentClientProfile: {
      readonly member: {
        readonly club: {
          readonly clients: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly eligibleForEvent?: boolean | null | undefined;
                readonly email?: string | null | undefined;
                readonly firstName?: string | null | undefined;
                readonly id?: string;
                readonly lastName?: string | null | undefined;
                readonly memberGroups?: ReadonlyArray<{
                  readonly id: string;
                } | null | undefined> | null | undefined;
                readonly membershipType?: {
                  readonly id: string;
                } | null | undefined;
                readonly phoneNumber?: {
                  readonly nationalNumber: string;
                } | null | undefined;
                readonly preferredTransportationType?: {
                  readonly code: TransportationCode | null | undefined;
                  readonly customCode: string | null | undefined;
                  readonly id: string;
                } | null | undefined;
                readonly profileImage?: {
                  readonly publicId: string;
                } | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        };
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type CustomerListQuery = {
  response: CustomerListQuery$data;
  variables: CustomerListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agendaId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventIdToExcludeParticipantsFromResults"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeTransportationType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "players"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slotId"
},
v6 = [
  {
    "kind": "Literal",
    "name": "active",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "agendaId",
    "variableName": "agendaId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 12
  },
  {
    "kind": "Variable",
    "name": "notRegisteredForEventId",
    "variableName": "eventIdToExcludeParticipantsFromResults"
  },
  {
    "kind": "Variable",
    "name": "players",
    "variableName": "players"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nationalNumber",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "eventId",
      "variableName": "eventIdToExcludeParticipantsFromResults"
    }
  ],
  "kind": "ScalarField",
  "name": "eligibleForEvent",
  "storageKey": null
},
v13 = [
  (v7/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberGroup",
  "kind": "LinkedField",
  "name": "memberGroups",
  "plural": true,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "CustomerType",
  "kind": "LinkedField",
  "name": "membershipType",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v16 = {
  "condition": "includeTransportationType",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "slotId",
          "variableName": "slotId"
        }
      ],
      "concreteType": "TransportationType",
      "kind": "LinkedField",
      "name": "preferredTransportationType",
      "plural": false,
      "selections": [
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": [
    {
      "alias": "publicId",
      "args": null,
      "kind": "ScalarField",
      "name": "renderingKey",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v6/*: any*/),
                        "concreteType": "ClientConnection",
                        "kind": "LinkedField",
                        "name": "clients",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClientEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PhoneNumber",
                                        "kind": "LinkedField",
                                        "name": "phoneNumber",
                                        "plural": false,
                                        "selections": [
                                          (v11/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v12/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      (v17/*: any*/)
                                    ],
                                    "type": "Customer",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "CustomerListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v6/*: any*/),
                        "concreteType": "ClientConnection",
                        "kind": "LinkedField",
                        "name": "clients",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClientEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v18/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PhoneNumber",
                                        "kind": "LinkedField",
                                        "name": "phoneNumber",
                                        "plural": false,
                                        "selections": [
                                          (v11/*: any*/),
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v12/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      (v17/*: any*/)
                                    ],
                                    "type": "Customer",
                                    "abstractKey": null
                                  },
                                  (v19/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/)
                ],
                "storageKey": null
              },
              (v19/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d61db1b16d88cab718d5097e0ccd57e3",
    "id": null,
    "metadata": {},
    "name": "CustomerListQuery",
    "operationKind": "query",
    "text": "query CustomerListQuery(\n  $search: String\n  $players: [ID]\n  $agendaId: ID\n  $eventIdToExcludeParticipantsFromResults: ID\n  $slotId: ID!\n  $includeTransportationType: Boolean!\n) {\n  session {\n    currentClientProfile {\n      __typename\n      member {\n        __typename\n        club {\n          clients(first: 12, search: $search, players: $players, agendaId: $agendaId, active: true, notRegisteredForEventId: $eventIdToExcludeParticipantsFromResults) {\n            edges {\n              node {\n                __typename\n                ... on Customer {\n                  id\n                  firstName\n                  lastName\n                  email\n                  phoneNumber {\n                    nationalNumber\n                    id\n                  }\n                  eligibleForEvent(eventId: $eventIdToExcludeParticipantsFromResults)\n                  memberGroups {\n                    id\n                  }\n                  membershipType {\n                    id\n                  }\n                  preferredTransportationType(slotId: $slotId) @include(if: $includeTransportationType) {\n                    id\n                    code\n                    customCode\n                  }\n                  profileImage {\n                    publicId: renderingKey\n                  }\n                }\n                ... on Node {\n                  __isNode: __typename\n                  id\n                }\n              }\n            }\n          }\n          id\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f6800e8809f35e1592be1ff4d5f7a71c";

export default node;
